import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ADD_DAYCARE_MEAL_MENU } from '@/modules/API/meal/daycareSettingsHandler.ts'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { useMutation } from '@apollo/client'
import UserInput from '@/components/_custom/UserInput/userInput.tsx'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../meal.module.scss'

interface AddMealMenuDialogProps {
    open: boolean
    handleClose: () => void
    refetch: () => void
    daycareId: number
}

const AddMealMenuDialog: FunctionComponent<AddMealMenuDialogProps> = ({
    open,
    handleClose,
    refetch,
    daycareId
}: AddMealMenuDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [menu, setMenu] = useState<string>('')

    const [addMealMenu] = useMutation(ADD_DAYCARE_MEAL_MENU, {
        variables: {
            daycareId,
            menu
        },
        onCompleted: () => {
            refetch()
            handleClose()
            setMenu('')
            showNotificationSuccess(t('mealMenuAdded'))
        },
        onError: () => {
            handleClose()
            setMenu('')
            showNotificationError(t('mealMenuAddedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('addMealMenu')} />
            <DialogBody className={styles.DialogBody}>
                <UserInput
                    label={t('name')}
                    value={menu}
                    setValue={setMenu}
                    type='text'
                    verify='textLength'
                    textLength={{ min: 1, max: 256 }}
                    className={styles.UserInput}
                />
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type='close' onClick={handleClose} className={styles.Button} />
                    <ButtonTextIcon
                        type='add'
                        disabled={menu.length < 1 || menu.length > 256}
                        onClick={() => addMealMenu()}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default AddMealMenuDialog
